/**
 * Gera um UUID v4 para identificar o dispositivo (visitorId do Messenger).
 *
 * Prioriza `crypto.getRandomValues` (bem suportado e criptograficamente forte)
 * e mantém fallback com `Math.random()` para o caso raro de a Web Crypto API
 * estar ausente. Implementação própria em vez do pacote `uuid` porque ele não
 * está declarado no `package.json` — só existe como dependência transitiva.
 */
export function generateUuid(): string {
  // Aritmética (módulo/soma) em vez de operadores bitwise para respeitar a
  // regra de lint `no-bitwise`. `% 16` fixa a versão 4; `% 64 + 0x80` fixa a
  // variante RFC 4122.
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] % 16) + 0x40; // versão 4
    bytes[8] = (bytes[8] % 64) + 0x80; // variante RFC 4122

    let hex = '';
    for (let i = 0; i < bytes.length; i++) {
      hex += (bytes[i] + 0x100).toString(16).slice(1);
    }

    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    const v = c === 'x' ? r : (r % 4) + 8;

    return v.toString(16);
  });
}
